import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import store from 'store2';
import moment from "moment";

const module = 'activitylog';

export default class List extends Component {

	static contextTypes = {
		location: React.PropTypes.object
	};

	constructor(props, context) {
		super(props);


		this.columnModel = [
			{
				name: 'created',
				title: 'Datum',
				field: 'created',
				renderer: Renderers.DateTime,
				width: 140
			},
      {
        name: 'dTitle',
        title: 'Uživatel',
        field: 'dTitle',
        width: 200
      },
      {
        name: 'cTitle',
        title: 'Firma',
        field: 'cTitle',
        width: 200
      },
			{
				name: 'action',
				title: 'Akce',
				field: 'action',
				renderer: Renderers.DbInfo.bind(DbInfo.LogAction),
				width: 230
			},
      {
        name: 'detail',
        title: 'Detail',
        field: 'detail',
      },
		];

		const filterSchema = {
			fulltext: { class: SearchInput },
      dTitle: { class: FilterInput },
      cTitle: { class: FilterInput },
      action: { class: Select, options: DbInfo.LogAction },
      created: { class: DateRange,
        ranges: {
          'Dnes': [moment(), moment()],
          'Včera': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Tento týden': [moment().startOf('isoweek'), moment().endOf('isoweek')],
          'Tento měsíc': [moment().startOf('month'), moment().endOf('month')],
          'Minulý týden': [moment().subtract(1, 'week').startOf('isoweek'), moment().subtract(1, 'week').endOf('isoweek')],
          'Minulý měsíc': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        }},
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};
		this.filter = new FormManager(filterSchema);
		const sessionState = store.session.get('dg-' + module);
		// default
		let filter = {};
		// session
		if (sessionState && sessionState.filter) {
			filter = sessionState.filter;
		}
		this.defaultFilter = filter;
		this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'created', 'direction': 'desc'};

	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on(module + '.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener(module + '.change', this.changeListener);
	}

	handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm(module, row.t, row);
	}

	handleNewClick(e) {
		e.preventDefault();
		this.props.newTab();
	}

	render() {

		return (
			<Datagrid
				ref="datagrid"
				id={module}
				api="activitylog.getList"
				filters={['fulltext']}
				filter={this.filter}
				saveState={true}
				getRowClassName={null}
				columnModel={this.columnModel}
				defaultFilter={this.defaultFilter}
				forceFilter={this.filterUrl}
				defaultSort={this.defaultSort}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Activitylog/List.js